// extracted by mini-css-extract-plugin
export default {"heading":"OurTeam_heading__-fWjS","card":"OurTeam_card__k-37e","s_icon":"OurTeam_s_icon__G9nXp"};